module.exports = __webpack_public_path__ + "static/media/hp_ex_management.f203d34c.jpg";